// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gMQMy","title":"styles_title__ii3Bs","deviceInfo":"styles_deviceInfo__n3e5K","card":"styles_card__hYLHM"};